import * as React from "react";
import Popover from "@material-ui/core/Popover";
import { Divider, Grid } from "@material-ui/core";
import Box from "@material-ui/core/Box";
import MenuItem from "@material-ui/core/MenuItem";
import Person from "@material-ui/icons/Person";
import { makeStyles } from "@material-ui/core/styles";
import { IconBackground } from "../icon/IconBackground";
import Text from "../Text/Text";
import { useDispatch, useSelector } from "react-redux";
import { NavLink } from "react-router-dom";
import { getCustomer } from "../../store/home/selector";
import { RouteService } from "../../services/route.service";
import { getProfileData } from "../../store/profile/selector";
import "../Pages/page.css"
import { useAuth } from "react-oidc-context";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { logOutComplete } from "../../store/login/action";
import { emptyBuyPermitCart } from "../../store/buyPermits/action";
import { resetLoading } from "store/layout/action";

const useStyles = makeStyles({
  main: {
    display: "flex",
    flexDirection: "column",
    gap: "20px",
  },
  menuContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
  },
});

const Profile = (props) => {
  const history = useHistory();
  const dispatch = useDispatch();

  const shibboleth = useSelector((state) => state?.dashboardState?.shibbolethStatus);
  const customerName = useSelector(getCustomer);
  const { open, onClose } = props;
  const profileStore = useSelector(getProfileData);
  const openYN = Boolean(open);
  const auth = useAuth();
  const id = openYN ? "simple-popover" : undefined;

  const keycloakTokenSet = { name: 'logout' }

  function clearCookies() {
    document.cookie.split(";").forEach(function (c) {
      document.cookie = c.trim().split("=")[0] + '=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/';
    });
  }

  const handleLogout = () => {
    localStorage.clear();
    localStorage.setItem("keycloakTokenSet", JSON.stringify(keycloakTokenSet));

    if (shibboleth?.data?.buyerAuthentication == "Shibboleth") {
      console.log("Is Shibboleth");
      sessionStorage.clear();
      clearCookies();

      auth.signoutRedirect({
        id_token_hint: auth.user?.id_token,
        post_logout_redirect_uri: window.location.origin + RouteService.home(`${customerName}/`),
      });
    } else {
      console.log("NOT Shibboleth");
      history.push(RouteService.login(customerName));
    }

    dispatch(resetLoading());
    dispatch(logOutComplete());
    dispatch(emptyBuyPermitCart());
  };

  const classes = useStyles();
  return (
    <>
      <Popover
        id={id}
        open={openYN}
        anchorEl={open}
        onClose={onClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "center",
          horizontal: "center",
        }}
      >
        <Grid xs={12} md={12} className="profile_nav">
          <Box p={2}>
            <Grid container justify="center" spacing={4}>
              <Grid item>
                <IconBackground
                  shape="circle"
                  color="white"
                  background="mediumGray"
                  p={2}
                >
                  <Person />
                </IconBackground>
              </Grid>
            </Grid>
          </Box>
          <Box p={2}>
            <div className={classes.main}>
              <div>
                <Text align="center">
                  <b>
                    {(profileStore &&
                      profileStore.endUserAccountEntity &&
                      profileStore.endUserAccountEntity.person.firstName +
                      " " +
                      profileStore.endUserAccountEntity.person.lastName) ||
                      ""}
                  </b>
                </Text>
                <Divider />
              </div>
              <div className={classes.menuContainer}>
                <MenuItem tabIndex={0} component={NavLink} to={RouteService.profilePage(customerName)}>
                  <Text color="primary"> My Account</Text>
                </MenuItem>
                <MenuItem tabIndex={0} onClick={handleLogout}>
                  <Text color="primary">Logout</Text>
                </MenuItem>
              </div>
            </div>
          </Box>
        </Grid>
      </Popover>
    </>
  );
};
export default Profile;
